import type {PaginationDisplayMode} from '../types/Api';

/** Applied when a preset's settings predate the paginationDisplayMode field. */
export const DEFAULT_PAGINATION_DISPLAY_MODE: PaginationDisplayMode = 'BUTTONS';
